<div class="row m-0 h-100">
    <div class="container w-100">
        <router-outlet></router-outlet>
    </div>
</div>